const handleCloseFormParamFreq = {
  confirm: 'Do you really want to cancel the changes?',
  title: 'UNSAVED CHANGES'
};

export default handleCloseFormParamFreq;
